import { Outlet } from 'react-router-dom';

// Members and Invites are separate pages in the cloud's Team group (cloud-spec
// §7.1), each with its own header, so this layout only renders the page.
export let OrganizationSettingsTeamLayout = () => <Outlet />;
